/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./liveChange.vue?vue&type=template&id=28248c73&scoped=true&"
import script from "./liveChange.vue?vue&type=script&lang=js&"
export * from "./liveChange.vue?vue&type=script&lang=js&"
import style0 from "./liveChange.vue?vue&type=style&index=0&id=28248c73&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28248c73",
  null
  
)

export default component.exports